import React, { useState, useEffect, useContext } from 'react';
import { KFLButton, KFLInput } from '@kamstrup/kamstrup-frontend-library';
import Translate from '../../shared/localization/localize';
import { submitForm } from '../../../utils';
import { LocaleCtx } from '../../../contexts/locale.context';
import useTxRequest from '../../../modules/dialogs/transfer/useTxRequest';
import * as m from '../../../modules/dialogs/transfer/messages';
import Scrim from '../../shared/scrim';

const TxRequestForm: React.FC = () => {
  const { translate } = useContext(LocaleCtx);
  const {
    addDevice,
    isValidForm,
    validateStatus,
    isMinLength,
  } = useTxRequest();
  const [key, setKey] = useState('');
  const errorMsg = validateStatus.errorMsg;
  const isFetching = validateStatus.isFetching;

  useEffect(() => {
    isValidForm(key, true);
  }, [key]);

  const resetKey = () => setKey('');
  const insertDevice = () => addDevice(key, resetKey);

  const isLongEnoughKey = isMinLength(key);
  const error = !isLongEnoughKey
    ? ''
    : errorMsg && errorMsg !== m.msgDuplicateError && errorMsg !== m.msgBadFormatSN
    ? m.msgInvalidDeviceError
    : errorMsg;

  const isReadyToAdd = isLongEnoughKey && (error !== m.msgBadFormatSN );

  return (
    <Scrim
      fullHeight
      mode='Vertical'
      isActive={isFetching}
      label={m.msgValidating}
      iconSize={16}
    >
      <div className="tx_req_form">
        <div
          className="tx_req_form_fields"
          onKeyDown={submitForm(insertDevice)}
        >
          <KFLInput
            id="dg-tx-req-input-sn"
            label={translate(m.msgSnLabel)}
            placeholder={translate(m.msgSnPH)}
            type="text"
            value={key}
            onChange={setKey}
            validators={[{errorMessage: ()=> '', expression: /^[a-zA-Z]{3}\d{7,10}$/ }]}
          />
        </div>
        <div className="tx_req_feedback">
          {error && (
            <div className="error">
              <Translate message={error} />
            </div>
          )}
        </div>
        <KFLButton
          id="dg-tx-req-btn-add"
          onClick={insertDevice}
          disabled={!isReadyToAdd}
        >
          {translate(m.msgAddDeviceBtn)}
        </KFLButton>
      </div>
    </Scrim>
  );
};

export default TxRequestForm;
